/**
 * Front-end feature flags.
 *
 * EMAIL_ENABLED — master switch for the outreach email channel. Backed by
 * Microsoft Graph (settings.OUTREACH_EMAIL_PROVIDER=msgraph) as the active
 * provider; SendGrid stays wired but dormant as a fallback. Outbound send
 * was verified live (real draft-then-send through sender.send_direct())
 * before this flag was flipped; inbound Delta Query sync is verified by
 * the mocked test suite and is being confirmed live separately. When false,
 * every email
 * affordance is hidden AND the backend refuses to send email (see
 * settings.OUTREACH_EMAIL_ENABLED), so nothing can slip through while the
 * app is running. Keep both flags in sync.
 */
export const EMAIL_ENABLED = true;

// Channels the outreach UI should offer. Telegram, like WhatsApp, is always
// offered — whether it actually works for a given tenant depends on whether
// they've connected a Telegram channel account (Org Settings → Outreach
// Channels), not a build-time flag. An unconnected tenant sees the option but
// gets a clear "not configured" result on send, same as WhatsApp already
// degrades when WATI isn't set up — never a silent failure.
export const OUTREACH_CHANNELS = EMAIL_ENABLED ? ["whatsapp", "telegram", "email"] : ["whatsapp", "telegram"];

export default { EMAIL_ENABLED, OUTREACH_CHANNELS };
